export default __webpack_public_path__ + "static/mission-rabies-logo-57cdc2f4a7893e2a60938bb578b570ba.png";